export enum VideoCategoryEnum {
    StationSpecific = "Station Specific",
    Cancel = "Cancel",
    Delay = "Delay"
}